import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = ['requesterNotifiedIndicator']
  static values = { clearNotificationUrl: String }

  requesterNotifiedIndicatorTargetConnected(element) {
    $(element)?.tooltip({ trigger: 'hover' })
  }

  async clearNotification(event) {
    event.preventDefault()

    // Hide the tooltip
    if (this.hasRequesterNotifiedIndicatorTarget)
      $(this.requesterNotifiedIndicatorTarget)?.tooltip('hide')

    // Show confirmation dialog
    if (!confirm('Are you sure you want to clear this notification?'))
      return

    // Trigger request to clear the notification
    const response =
      await post(
        this.clearNotificationUrlValue, {
          responseKind: 'turbo-stream',
          credentials: 'same-origin'
        }
      )

    if (!response.ok)
      console.error('Failed to clear notification:', response)
  }
}
